/* MAHA — Cotiza por WhatsApp (header desktop + drawer móvil).
   El href ya es funcional al renderizar (Liquid url_encode, ver
   whatsapp-quote-button.liquid); aquí se re-codifica con encodeURIComponent
   real (evita el "+"-para-espacio de url_encode) y se registra el evento
   whatsapp_quote_click vía Shopify.analytics.publish si existe. */
(function () {
  'use strict';
  if (window.__mahaWhatsappQuoteInit) return;
  window.__mahaWhatsappQuoteInit = true;

  // MAHA: extraido a funcion nombrada y expuesto en window para que el bloque
  // whatsapp_quote de la PDP (sections/main-product.liquid) pueda reconstruir
  // el href cuando cambie variante/cantidad, sin duplicar esta formula.
  function updateHref(el) {
    var number = el.getAttribute('data-whatsapp-number');
    var message = el.getAttribute('data-whatsapp-message');
    if (number && message !== null) {
      el.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
    }
  }
  window.MahaWhatsappQuote = { updateHref: updateHref };

  function init() {
    var links = document.querySelectorAll('[data-whatsapp-quote]');
    links.forEach(function (el) {
      updateHref(el);
      el.addEventListener('click', function () {
        var detail = {
          location: el.getAttribute('data-whatsapp-location') || '',
          page_type: (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.pageType) || document.body.getAttribute('data-template') || '',
          product_id: el.getAttribute('data-whatsapp-product-id') || null
        };
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish('whatsapp_quote_click', detail);
          }
        } catch (e) { /* analítica no disponible: no bloquear el enlace */ }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
